import styled, { css } from 'styled-components';

import { Col as BaseColumn } from '@/components/Col';
import { Flex } from '@/components/Flex';
import { SectionHeader } from '@/components/SectionHeader';
export const Col = styled(BaseColumn)`
  height: 100%;
`;

export const Box = styled(Flex)`
  display: flex;
  flex-direction: column;
  min-height: 245px;
  height: 100%;
  ${({ theme }) => css`
    @media (min-width: ${theme.breakpoints.xs}) {
      width: 100%;
      min-height: 135px;
    }
  `}
`;

export const Header = styled(SectionHeader)`
  padding: 0;
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.bold};
    font-family: ${theme.fontFamilies.italianPlate};
    line-height: ${theme.spacing(3)};
    text-align: center;
  `}
`;

export const NewContent = styled(Flex)`
  text-align: center;
  ${({ theme }) => css`
    padding: ${theme.spacing(2, 0)};
    min-height: ${theme.spacing(16)};
  `}
`;

export const Wapper = styled(Flex)`
  height: 100%;
  width: auto;
`;

export const ImageTeaserCol = styled(BaseColumn)`
  grid-column: span 12;
  min-height: 245px;
  height: 100%;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      grid-column: span 4;
    }
  `}
`;
